/* @flow */
import * as React from "react";
import Backbone from "backbone";
import LocalSettings from "nexia_mobile/models/local_settings";

type Props = {
  listenTo: Backbone.Events,
  // False positive
  // eslint-disable-next-line react/no-unused-prop-types
  events: Array<string>,
  getNodeToStyle: () => ?HTMLElement,
};

// For debugging; flashes an inset box-shadow on the target DOM element when
// Backbone events occur. Enable with the support code "draw_updates"
export default class DrawUpdates extends React.Component<Props> {
  componentDidMount() {
    this._startListening(this.props);
  }

  componentWillUnmount() {
    this._stopListening(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.listenTo === this.props.listenTo) {
      return;
    }
    this._stopListening(this.props);
    this._startListening(nextProps);
  }

  _startListening(props: Props) {
    if (!LocalSettings.getDrawUpdates()) {
      return;
    }
    props.listenTo.on(props.events.join(" "), this._flash, this);
  }

  _stopListening(props: Props) {
    props.listenTo.off(null, null, this);
  }

  _flash = () => {
    if (!LocalSettings.getDrawUpdates()) {
      this._stopListening(this.props);
      return;
    }

    const el = this.props.getNodeToStyle();
    if (el == null) {
      return;
    }
    el.style.boxShadow = "inset 0 0 4px red";
    setTimeout(() => {
      el.style.boxShadow = "";
    }, 200);
  };

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/DrawUpdates.jsx